import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=d2afb7d0&"
import script from "./Pagination.ts?vue&type=script&lang=ts&"
export * from "./Pagination.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports